<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal id="modal-details" size="xl" hide-footer ref="appeal-details" title="Appeal File">
        <b-col cols="12">
          <AppealFile :reservation="reservation" :message="appealMessage" :time="appealTime"/>
        </b-col>
      </b-modal>
    </b-row>

    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Reservation Appeal Requests</span>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12">
        <div class="mx-auto">
          <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
        </div>
        <b-row>
          <b-col cols="12">
            <table class="min-w-full leading-normal">
              <thead>
              <tr class="border-b border-t border-grey">
                <th class="t-header">Tracking No.</th>
                <th class="t-header">Name</th>
                <th class="t-header">Entity Type</th>
                <th class="t-header">Sub-Entity Type</th>
                <th class="t-header">Submission Date</th>
                <th class="t-header">Expiry Date</th>
                <th class="t-header text-center">Action</th>
              </tr>
              </thead>

              <tbody>
              <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(submission, idx) in appeals" :key="idx">
                <td class="t-body text-blue font-bold">
                  <span v-if="submission.reservation">{{submission.reservation.no}}</span>
                </td>
                <td class="t-body font-bold">
                  <span v-if="submission.reservation">{{submission.reservation.nameOptions[0].name}} ({{submission.reservation.nameOptions.length}})</span>
                </td>
                <td class="t-body text-capitalize">
                  <span v-if="submission.reservation">{{submission.reservation.type}}</span>
                </td>
                <td class="t-body text-capitalize">
                  <span v-if="submission.reservation">{{cleanEntityType(submission.reservation.subType)}}</span>
                </td>
                <td class="t-body">
                  {{dateTimeFormat(submission.createdAt)}}
                </td>
                <td class="t-body">
                  <span v-if="submission.reservation">{{dateFormat(submission.reservation.expiresOn)}}</span>
                </td>
                <td class="t-body">
                  <div class="flex">
                    <button @click="view(submission)" class="bg-blue px-2 py-1 rounded-sm text-white w-full">View</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td v-if="appeals.length === 0" colspan="8" class="bg-inertgrey text-center py-1">
                  <span class="text-sm">No results found</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mx-1" v-if="pagination.totalPages > 1">
          <b-col cols="1">
            <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
          </b-col>
          <b-col cols="1">
            <b-row>
              <b-col cols="12">
                <p class="paginate-details text-center">
                  <b-badge class="bg-blue text-white">
                    {{currentPage}}/{{pagination.totalPages}}
                  </b-badge>
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="1" >
            <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
          </b-col>
          <b-col class="9"></b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import AppealFile from "@/views/home/services/reservation/appeals/AppealFile";

export default {
  name: "ApprovedReservationExtensions",
  components: {AppealFile},
  data(){
    return{
      selectedId:null,
      margin:"2px",
      hasContent:false,
      extension:{},
      loading:true,
      message:null,
      currentPage:1,
      reservation:null,
      appealMessage:null,
      appealTime:null,
      limit:6,
      form:{
        extensionId:null,
        status:null
      },
      appeals:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["fetchReservationAppeals", "fetchAnalysisReport", "emptyAnalysisReport", "fetchReservationStatuses"]),
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    fetch(){
      let data = {
        page:this.currentPage,
        limit:this.limit,
      }
      this.loading = true
      this.fetchReservationAppeals(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    view(submission){
      this.extension = submission
      this.form.reservationId = submission.id
      this.reservation = submission.reservation
      this.appealMessage = submission.description
      this.appealTime = submission.createdAt

      this.fetchReservationStatuses(submission.reservation.id)

      let data = submission.reservation
      if(data != null){
        let size = data.nameOptions.length
        let names = []
        this.hasContent = true
        this.form.reservationId = data.id
        this.emptyAnalysisReport()
        for (let i = 0; i < size; i++){
          names.push(data.nameOptions[i].name.trim())
        }
        this.fetchAnalysisReport(names)
        if(size == 1){
          this.selectedId = data.nameOptions[0].id
        }
      }

      this.$refs["appeal-details"].show()
    },
    checkForUpdates(){
      this.loading = true
      window.location.reload()
    },
    clearForm(){
      this.form = {
        description:null,
        reservationId:null,
        status:null
      }
    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    }
  },
  computed:{
    ...mapGetters([ "getReservationAppeals", "getReservationSuccess", "getReservationError", "getAppealSuccess"]),
  },
  watch:{
    getReservationAppeals(data){
      this.loading = false
      this.appeals = data.content
      this.pagination = {
        totalPages:data.totalPages,
        totalElements:data.totalElements
      }
    },
    getAppealSuccess(){
      this.$refs["appeal-details"].hide();
      this.fetch()
    },
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.icon{
  width: 170px;
}

.view-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-blue text-blue text-xs w-full;
}

.view-btn:hover{
  @apply bg-blue text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>